import { render, staticRenderFns } from "./pgd-timeline.vue?vue&type=template&id=045dfd48&scoped=true"
import script from "./pgd-timeline.vue?vue&type=script&lang=js"
export * from "./pgd-timeline.vue?vue&type=script&lang=js"
import style0 from "./pgd-timeline.vue?vue&type=style&index=0&id=045dfd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045dfd48",
  null
  
)

export default component.exports